import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import type { Society } from "../../types/Society.types";

type ActiveCompanyStatus = "idle" | "loading" | "ready" | "error";

interface ActiveCompanyState {
  companies: Society[];
  activeId: string | null;
  status: ActiveCompanyStatus;
}

const initialState: ActiveCompanyState = {
  companies: [],
  activeId: null,
  status: "idle",
};

export const activeCompanySlice = createSlice({
  name: "activeCompany",
  initialState,
  reducers: {
    companiesLoading: (state) => {
      state.status = "loading";
    },
    companiesLoaded: (state, action: PayloadAction<{ companies: Society[]; preferredId?: string | null }>) => {
      const { companies, preferredId } = action.payload;
      state.companies = companies;
      state.status = "ready";
      // Orden: la elegida en esta sesión, la guardada en el navegador y, si ninguna sigue en la lista, la primera.
      const candidates = [state.activeId, preferredId];
      const found = candidates.find((id) => id && companies.some((c) => c.id === id));
      state.activeId = found ?? companies[0]?.id ?? null;
    },
    companiesFailed: (state) => {
      state.status = "error";
    },
    setActiveCompany: (state, action: PayloadAction<string>) => {
      state.activeId = action.payload;
    },
  },
});

export const { companiesLoading, companiesLoaded, companiesFailed, setActiveCompany } =
  activeCompanySlice.actions;

export const selectActiveCompany = (state: { activeCompany: ActiveCompanyState }) =>
  state.activeCompany.companies.find((c) => c.id === state.activeCompany.activeId) || null;

export default activeCompanySlice.reducer;
